import { runAggregationOnce } from '@/utils/aggregation';
import { buildAggregations, parseAggregationResults, createSignals } from './signals.utils.js';
import { SIGNAL_TYPES } from './signals.constants.js';
import { getAppId } from '@/vuex/modules/trends/trends-settings.module.js';

const signals = {
    namespaced: true,
    state: {
        signals: null,
        isLoading: null,
        error: null,
    },
    mutations: {
        setSignals (state, { signals }) {
            state.signals = signals;
        },
        setLoading (state, { isLoading }) {
            state.isLoading = isLoading;
        },
        setError (state, { error }) {
            state.error = error;
        },
    },
    actions: {
        async fetchSignals ({ commit, rootGetters, dispatch }) {
            commit('setLoading', { isLoading: true });
            commit('setError', { error: null });

            try {
                const signalsToFetch = [SIGNAL_TYPES.VISITOR_ADOPTION];

                const appId = await getAppId(rootGetters, dispatch);
                const hasShowAnonymousFlag = !!rootGetters['subscription/getFeatureFlag']('showAnonymous');

                const [aggregations, breakpoints] = buildAggregations(signalsToFetch, {
                    appId,
                    hasShowAnonymousFlag,
                });

                const rawData = await Promise.all(
                    aggregations.map((agg) => runAggregationOnce(agg)),
                );

                const extractedData = parseAggregationResults(signalsToFetch, breakpoints, rawData);

                const signals = createSignals(signalsToFetch, extractedData);

                commit('setSignals', { signals });
                commit('setLoading', { isLoading: false });

                return signals;

            } catch (error) {
                commit('setError', { error: error.message || 'Failed to fetch signals' });
                commit('setLoading', { isLoading: false });
                throw error;
            }
        },
    },
    getters: {
        signals: (state) => state.signals || [],
        isLoading: (state) => state.isLoading,
        hasError: (state) => !!state.error,
        error: (state) => state.error,
    },
};

export default signals;